var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-container"},[_c('h3',{staticClass:"text-center"},[_vm._v(" Settings ")]),_c('v-checkbox',{attrs:{"prepend-icon":"mdi-cellphone-basic ","input-value":_vm.includeMobileGatewayInDashboard,"label":"Include mobile gateways in dashboard"},on:{"change":_vm.toggleIncludeMobileGatewaysInDashboard}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }